import React, { useContext } from 'react';
import moment from 'moment';

import JobListContext from '../app/context/jobListContext';
import AssetListContext from '../app/context/assetListContext';
import reactiveJob from "../app/interfaces/reactiveJob";
import PlannedJob from "../app/interfaces/plannedJob";
import Asset from "../app/interfaces/asset";
import ReactiveJob from "../app/interfaces/reactiveJob";

const useSort = () => {
  const { reactiveJobList,plannedJobList, filteredPlannedJobList, filteredReactiveJobList, updateFilteredReactiveJobList, updateFilteredPlannedJobList } = useContext(JobListContext)
  const { filteredAssetList, assetList, updateFilteredAssetList } = useContext(AssetListContext);

  const sortReactive = (filter: string ) => {
    let newSortedList: ReactiveJob[] = filteredReactiveJobList.length? filteredReactiveJobList: reactiveJobList;

    let SLAMapping = {
      'missedDeadline': 5,
      'urgentlyUpcoming': 4,
      'upcomingToday': 3,
      'upcoming': 2,
      'doneOnTime': 1,
    };

    updateFilteredReactiveJobList([...newSortedList].sort((a: reactiveJob, b: reactiveJob) => {
      switch(filter) {
        case 'SLA (Urgent First)':
          return (SLAMapping[a.SLAOnsite] < SLAMapping[b.SLAOnsite])? 1: -1;
        case 'SLA (Urgent Last)':
          return (SLAMapping[a.SLAOnsite] > SLAMapping[b.SLAOnsite])?  1: -1;
        case 'Latest':
          if(a.ReceivedDatetime == '') return -1;
          return moment(a.ReceivedDatetime.split("+")[0],'YYYY-MM-DDThh:mm:ss').isBefore(moment(b.ReceivedDatetime.split("+")[0], 'YYYY-MM-DDThh:mm:ss'),'second')?  1: -1;
        case 'Oldest':
          if(a.ReceivedDatetime == '') return -1;
          return moment(b.ReceivedDatetime.split("+")[0],'YYYY-MM-DDThh:mm:ss').isAfter(moment(b.ReceivedDatetime.split('+')[0],'YYYY-MM-DDThh:mm:ss'),'second')?  1: -1;
        case 'Highest Critical Code':
          if(a.PriorityCode == 'PM' || a.PriorityCode == 'QU') return 1;
          return a.PriorityCode > b.PriorityCode?  1: -1;
        case 'Lowest Critical Code':
          if(a.PriorityCode == 'PM' || a.PriorityCode == 'QU') return -1;
          return a.PriorityCode < b.PriorityCode?  1: -1;
      }
    }));
  };

  const sortPlanned = (filter: string) => {
    let newSortedList: PlannedJob[] = filteredPlannedJobList.length? filteredPlannedJobList: plannedJobList;

    const openFirst = {
      "Open": 2,
      "Completed": 1,
      "Incomplete": 0,
    };
    const completeFirst = {
      "Completed": 2,
      "Open": 1,
      "Incomplete": 0,
    };
    const incompleteFirst = {
      "Incomplete": 2,
      "Open": 1,
      "Completed": 0,
    };

    updateFilteredPlannedJobList([...newSortedList].sort((a: PlannedJob, b:PlannedJob) => {
      switch(filter) {
        case 'Status (Open First)':
          return openFirst[a.Status] < openFirst[b.Status]? 1: -1;
        case 'Status (Completed First)':
          return completeFirst[a.Status] < completeFirst[b.Status]? 1: -1;
        case 'Status (Incomplete First)':
          return incompleteFirst[a.Status] < incompleteFirst[b.Status]? 1: -1;
        case 'Earliest':
          return moment(a.RoutineDueDate).unix() - moment().unix() > moment(b.RoutineDueDate).unix() - moment().unix()? 1: -1;
        case 'Latest':
          return moment(a.RoutineDueDate).unix() - moment().unix() < moment(b.RoutineDueDate).unix() - moment().unix()? 1: -1;
      }
    }));
  };

  const sortAsset = (filter: string) => {
    let newAssetList: Asset[] = filteredAssetList.length?  filteredAssetList: assetList;
    let assetConditionMapping = {
      '5 (VERY POOR)' : 1,
      '4 (POOR)': 2,
      '3 (MODERATE)': 3,
      '2 (GOOD)': 4,
      '1 (VERY GOOD)': 5,
    };

    updateFilteredAssetList([...newAssetList].sort((a,b) => {
      switch(filter) {
        case 'Condition (Highest First)':
          if(a.Condition == undefined || a.Condition == '') return 1;
          return assetConditionMapping[a.Condition] < assetConditionMapping[b.Condition]? 1: -1;
        case 'Condition (Poorest First)':
          if(a.Condition == undefined || a.Condition == '') return 1;
          return assetConditionMapping[a.Condition] > assetConditionMapping[b.Condition]? 1: -1;
        case 'Name (A-Z)':
          return a.ItemDescription > b.ItemDescription? 1: -1;
        case 'Name (Z-A)':
          return a.ItemDescription < b.ItemDescription? 1: -1;
      }
    }))
  };

  return {
    sortReactive,
    sortPlanned,
    sortAsset,
  }
};

export default useSort;